export default "__VITE_ASSET__nZXqGLcF__"